const navigationItemType = {
    DOCUMENT : 1,

    FORM : 2,

    NONE : 3,

    QUOTES : 5,

    PROPOSALS : 6,

    PROPOSAL : 7,

    PROPOSAL_BUILDER : 8,

    BINDER_BUILDER : 9,

    POLICIES : 10,

    POLICY : 11,

    ACCOUNT : 12,

    REPORTS : 13,

    CUSTOM : 14,

    URL : 15,

    ACCOUNT_SUBMISSIONS : 16,

    QUOTE : 17,

    POLICY_ISSUANCE : 18,

    POLICY_CANCELLATION : 19,

    POLICY_REINSTATEMENT : 20,

    POLICY_REWRITE : 21,

    ENDORSEMENT : 22

};

angular.module('gw-um-j2js')
    .constant('navigationItemType', navigationItemType);